import { gql } from '@apollo/client';

export type DispatchEventTaskOrderBatchUpdateInput = {
  ids?: number[];
  dispatchEventTaskId?: number;
  isCompleted?: number;
  isSentMq?: number;
  retryCount?: number;
};

export type BatchUpdateDispatchEventTaskOrderStatusResponse = {
  opsToolBatchUpdateDispatchEventTaskOrderStatus: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export type ArchiveDispatchEventTaskResponse = {
  opsToolArchiveDispatchEventTask: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const ARCHIVE_DISPATCH_EVENT_TASK = gql`
  mutation OpsToolArchiveDispatchEventTask($dispatchEventTaskId: Long!) {
    opsToolArchiveDispatchEventTask(dispatchEventTaskId: $dispatchEventTaskId) {
      success
      code
      message
      updatedCount
    }
  }
`;

export type CancelArchiveDispatchEventTaskResponse = {
  opsToolCancelArchiveDispatchEventTask: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const CANCEL_ARCHIVE_DISPATCH_EVENT_TASK = gql`
  mutation OpsToolCancelArchiveDispatchEventTask($dispatchEventTaskId: Long!) {
    opsToolCancelArchiveDispatchEventTask(dispatchEventTaskId: $dispatchEventTaskId) {
      success
      code
      message
      updatedCount
    }
  }
`;

export type DeleteDispatchEventTaskOrdersResponse = {
  opsToolDeleteDispatchEventTaskOrders: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const DELETE_DISPATCH_EVENT_TASK_ORDERS = gql`
  mutation OpsToolDeleteDispatchEventTaskOrders($dispatchEventTaskId: Long!) {
    opsToolDeleteDispatchEventTaskOrders(dispatchEventTaskId: $dispatchEventTaskId) {
      success
      code
      message
      updatedCount
    }
  }
`;

export type DeleteDispatchEventTaskOrderHistoriesResponse = {
  opsToolDeleteDispatchEventTaskOrderHistories: {
    success: boolean;
    code: string;
    message: string;
    updatedCount: number | null;
  };
};

export const DELETE_DISPATCH_EVENT_TASK_ORDER_HISTORIES = gql`
  mutation OpsToolDeleteDispatchEventTaskOrderHistories($dispatchEventTaskId: Long!) {
    opsToolDeleteDispatchEventTaskOrderHistories(dispatchEventTaskId: $dispatchEventTaskId) {
      success
      code
      message
      updatedCount
    }
  }
`;

export const BATCH_UPDATE_DISPATCH_EVENT_TASK_ORDER_STATUS = gql`
  mutation OpsToolBatchUpdateDispatchEventTaskOrderStatus($input: OpsDispatchEventTaskOrderBatchUpdateInput!) {
    opsToolBatchUpdateDispatchEventTaskOrderStatus(input: $input) {
      success
      code
      message
      updatedCount
    }
  }
`;
